import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {CampoData} from '../../components/processo/CamposProcesso.jsx';

/* Aba "Agendamento": período (data e hora) em que o agendamento de atendimento fica aberto. */
export default function TabAgendamento({control, errors}) {
    return (
        <Grid container spacing={3}>
            <CampoData control={control} errors={errors} nome='dataInicialAgendamento' rotulo='Data início agendamento *' comHora/>
            <CampoData control={control} errors={errors} nome='dataFinalAgendamento' rotulo='Data término agendamento *' comHora/>
        </Grid>
    );
}

TabAgendamento.propTypes = {
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
